import { Component, OnInit, Input } from '@angular/core';
import { ApplicationService } from 'app/services/application.service';
import { Params, Router, ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { ComplianceLegalComponent } from 'app/carrier-account/compliance-legal/compliance-legal.component';
import { CompliancereturnsService } from 'app/services/compliancereturns.service';
import { DatePipe } from '@angular/common'
import * as internal from 'assert';

@Component({
  selector: 'app-compliance-details',
  templateUrl: './compliance-details.component.html',
  styleUrls: ['./compliance-details.component.css']
})
export class ComplianceDetailsComponent implements OnInit {
  @Input() dataCntrl: any;
  compID: any = null;
   isLoading = false;
  caConfirmObj: any = {};
  message: any;
  oldAppId:any=null;
  appData:any=null;
  duration:any="";
  permitType:any="";
  permitInfo:any="";
  complianceDetails: any;
  profileForm: FormGroup;
  currentComplianceDetail :any;
  isView : boolean = false;

  constructor(
    private applicationService: ApplicationService,private complianceService: CompliancereturnsService ,private router: Router, private activeRoute: ActivatedRoute, public datepipe: DatePipe) { }

  ngOnInit() {
    //console.log('Carrier');
    console.log( this.dataCntrl.compID + "detail");
    
    this.activeRoute.params.subscribe((params: Params) => {
      // this.dataCntrl.application.id = params['appID'];
      //console.log(params['id']);
      
      this.compID = this.dataCntrl.compID;
      
    
    });
   this.profileForm = new FormGroup({
      accNum: new FormControl(''),
      accName: new FormControl(''),
      adress1: new FormControl(''),
      adress2: new FormControl(''),
      adress3: new FormControl(''),
      permitNum: new FormControl(''),
      issueNum: new FormControl(''),
      permitType: new FormControl(''),
      faceVNum: new FormControl(''),
      startDate: new FormControl(''),
      expiryDate: new FormControl(''),
      duration: new FormControl(''),
      status: new FormControl(''),
      issueDate: new FormControl(''),
      route: new FormControl(''),
      passengers: new FormControl(''),
      registration: new FormControl(''),
      vin: new FormControl('')
    });
      // this.activeRoute.params.subscribe((params: Params) => {
      //   this.dataCntrl.application.id = params['appID'];
      //   //console.log(params['id']);
        
      
      // });
      this.getApplicationDetails(this.dataCntrl.compID);
    // if(localStorage.getItem("oldAppId")!=undefined && localStorage.getItem("oldAppId")!=null){
    //   this.oldAppId=localStorage.getItem("oldAppId");
    //   this.getApplicationDetails(this.dataCntrl.compID);
    // }
  }

  onSubmit() {
    // TODO: Use EventEmitter with form value
    console.log(this.profileForm.value);
  }
  
  getApplicationDetails(compID){
    this.isLoading=   true;
    this.complianceService.GetComplianceById(compID).subscribe(data => {
      //console.log(this.dataCntrl.accNum);
     this.currentComplianceDetail = data['complianceDetails'];
      var num = data['accountNum'];
     var town =   data['addressTown'];
     var postalCode =  data['postalCode'];
      if(data != null)
      {
        this.profileForm.controls['accNum'].setValue(num);
        this.profileForm.controls['accName'].setValue(data['carrier_name']);
        this.profileForm.controls['adress1'].setValue(data['physical_address_1']);
        this.profileForm.controls['adress2'].setValue(town);
        this.profileForm.controls['adress3'].setValue(postalCode);
        this.profileForm.controls['permitNum'].setValue(data['permit_num']);
        this.profileForm.controls['faceVNum'].setValue(data['face_value_num']);
        // this.profileForm.controls['issueDate'].setValue(data['application_id']);
        this.profileForm.controls['issueNum'].setValue(data['permit_issue_number']);
        this.profileForm.controls['permitType'].setValue(data['permit_type']);
        this.profileForm.controls['startDate'].setValue(this.datepipe.transform(data['date_valid_from'], 'dd/MM/yyyy'));
        this.profileForm.controls['expiryDate'].setValue(this.datepipe.transform(data['date_valid_to'], 'dd/MM/yyyy'));
        this.profileForm.controls['duration'].setValue(data['duration']);
        this.profileForm.controls['status'].setValue(data['status_description']);
        this.profileForm.controls['route'].setValue(data['route_summary']);
         this.profileForm.controls['passengers'].setValue(data['number_passengers']);
        this.profileForm.controls['registration'].setValue(data['registration_number']);
        this.profileForm.controls['vin'].setValue(data['vin']);
        this.isLoading = false;
      }
    });
    this.isLoading = false;
  }

  onActive(tab){

    var compDetailId = 0;    
    if(this.currentComplianceDetail != null && this.currentComplianceDetail.compliance_status != 2) //If status NOT 'Resolved'
    {
      compDetailId = this.currentComplianceDetail.id;
    }

      this.complianceService.createComplianceCertificateTransaction( this.dataCntrl.compID, compDetailId).subscribe(res => {
        console.log(res);
        this.dataCntrl.complianceDetail = res;
      this.applicationService.setTab(tab);
      });
    
  }
  continueRoute() {
    if (this.router.url.indexOf('change') > 0) {
      this.activeRoute.params.subscribe((params: Params) => {
        this.dataCntrl.application.id = params['appID'];
        const ctrlType = params['ctrlType'];
        if (ctrlType != 'vehicle' && this.router.url.indexOf('correction') < 0) {
          return this.applicationService.setTab(3);
        }
        if (ctrlType === 'vehicle') {
          return this.applicationService.setTab(2);
        }
        if (this.router.url.indexOf('correction') > 0) {
          return this.applicationService.setTab(1);
        }
      });

    }
    if (this.router.url.indexOf('duplicate') > 0)
      return this.applicationService.setTab(5);
  }
}
